export default "__VITE_ASSET__2c521e2d__"